import { render, staticRenderFns } from "./ViewPreviousBillings.vue?vue&type=template&id=12ea57ed"
import script from "./ViewPreviousBillings.vue?vue&type=script&lang=js"
export * from "./ViewPreviousBillings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports